import { BagError } from './BagError';

export class ATBError extends BagError {
  /**
   * @param {string} message
   */
  constructor(message) {
    super(message);
    this.name = 'ATBError';
  }
}
